import request from "@/utils/request";
/*参数设置*/
/*--1.新增检测类型*/
export function setsave(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/save",
    method: "post",
    data,
  });
}
/*--2.删除检测类型*/
export function setdelete(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/delete",
    method: "post",
    data,
  });
}
/*--3.获取检验列表*/
export function setgetList(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/getList",
    method: "post",
    data,
  });
}
/*--4.绑定检验类型*/
export function saveCategoryBinding(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/saveCategoryBinding",
    method: "post",
    data,
  });
}
/*--5.获取绑定数据列表*/
export function getCategoryBindings(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/getCategoryBindings",
    method: "post",
    data,
  });
}
/*--6.删除绑定检测类型*/
export function deleteCategoryBindings(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/deleteCategoryBindings",
    method: "post",
    data,
  });
}
/*--7.查询参数设置*/
export function getParameterSetting(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/getParameterSetting",
    method: "post",
    data,
  });
}
/*--8.保存参数设置*/
export function saveParameterSetting(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/saveParameterSetting",
    method: "post",
    data,
  });
}

/*--9.保存频率设置*/
export function saveTestFrequency(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/saveTestFrequency",
    method: "post",
    data,
  });
}
export function saveStationTest(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/saveStationTest",
    method: "post",
    data,
  });
}
/*--10.获取检测频率*/
// export function getTestFrequency(data) {
// 	return request({
// 		url: '/icps/system/sign/basics/qualityDetection/getTestFrequency',
// 		method: 'post',
// 		data
// 	})
// }
export function getStationTest(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/getStationTest",
    method: "post",
    data,
  });
}
/*--11.获取检测频率*/
export function getFirmDetection(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/getFirmDetection",
    method: "post",
    data,
  });
}
/*--12.获取验收标准*/
export function getNormByDetection(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/getNormByDetection",
    method: "post",
    data,
  });
}
/*--13.保存验收标准*/
export function saveNormByDetection(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/saveNormByDetection",
    method: "post",
    data,
  });
}
/*--1.公司质量参数-标号寿命-新增或修改*/
export function save_or_update(data) {
  return request({
    url: "/icps/system/sign/basics/bindingTime/save_or_update",
    method: "post",
    data,
  });
}

/*--1.公司质量参数-标号寿命-获取*/
export function queryBindingTime(data) {
  return request({
    url: "/icps/system/sign/basics/bindingTime/queryBindingTime",
    method: "post",
    data,
  });
}
/*--1.站点质量参数-标号寿命-新增或修改
 */
export function stationsave_or_update(data) {
  return request({
    url: "/icps/system/sign/basics/bindingTime/station/save_or_update",
    method: "post",
    data,
  });
}

/*--1.站点质量参数-标号寿命-获取
 */
export function stationqueryBindingTime(data) {
  return request({
    url: "/icps/system/sign/basics/bindingTime/station/queryBindingTime",
    method: "post",
    data,
  });
}

/*--1.站点质量参数-标号寿命-获取
 */
export function sortingProject(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/sortingProject",
    method: "post",
    data,
  });
}
/*--1.站点质量参数-标号寿命-获取
 */
export function getSpecificatioByName(params) {
  return request({
    url: "/icps/system/sign/basics/rawMaterials/getSpecificatioByName",
    method: "get",
    params,
  });
}

export function queryRawByName(params) {
  return request({
    url: "/icps/system/sign/basics/rawMaterials/queryRawByName",
    method: "get",
    params,
  });
}

/*--质量模板设置-查询
 */
export function queryVerifyTemplates(data) {
  return request({
    url: "/icps/system/basics/qualityDetectionCompany/queryVerifyTemplates",
    method: "post",
    data,
  });
}
/*--质量模板设置-增加
 */
export function saveVerifyTemplates(data) {
  return request({
    url: "/icps/system/basics/qualityDetectionCompany/saveVerifyTemplates",
    method: "post",
    data,
  });
}
/*--质量模板设置-删除
 */
export function deleteVerifyTemplates(data) {
  return request({
    url: "/icps/system/basics/qualityDetectionCompany/deleteVerifyTemplates",
    method: "post",
    data,
  });
}
